<form [formGroup]="form" class="flex flex-col space-y-2">
    <app-application-form-field>
        <mat-form-field appearance="outline" class="w-1/2">
            <mat-label>Purpose of Submission</mat-label>
            <mat-select formControlName="notificationCode" required>
                @for (
                    option of purposeOfSubmissionOptions;
                    track option.value
                ) {
                    <mat-option [value]="option.value">{{
                        option.label
                    }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </app-application-form-field>
    <mat-form-field appearance="outline" class="w-1/2">
        <mat-label>Call Sign of Existing FCC License</mat-label>
        <input
            formControlName="callSign"
            title="Call Sign of Existing FCC License"
            matInput
        />
    </mat-form-field>
    <div class="flex justify-between">
        <div class="flex space-x-2 items-center mb-[5px]">
            <h3 class="section-heading !mb-0">
                Call Signs/Locations or Path/Frequencies:
            </h3>

            @if (scheduleKFormFrequencies.invalid) {
                <img src="assets/svg/error_icon.svg" alt="Error Icon" />
            }
        </div>
        <div class="flex ml-auto pr-2">
            @if (this.shouldDisplayAttachmentWarningFlag) {
                <app-attachment-required-button></app-attachment-required-button>
            }
        </div>
        <app-grid-toolbar
            [gridApi]="gridApi"
            [options]="gridToolbarOptions"
        ></app-grid-toolbar>
    </div>
    <ag-grid-angular
        [context]="initializeGridContext()"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        class="ag-theme-quartz h-[450px] w-full"
    >
    </ag-grid-angular>
</form>
